import React from 'react';

import useAudiencesQuery from 'hooks/audiences/useAudiencesQuery';

import { AudienceModel } from 'models/audience.model';
import {
    FormulaAudienceIdModel,
    FormulaDetailModel,
} from 'models/formula.model';

import { SummaryItem } from './SummaryItem';

function getAudienceNames(
    audienceRefs: FormulaAudienceIdModel[],
    audiences: AudienceModel[] = [],
): string {
    return (
        audienceRefs
            .map(
                ({ audience_id }) =>
                    audiences.find((value) => value.id === audience_id)?.name,
            )
            .filter(Boolean)
            .join(', ') || 'All users'
    );
}
export const AudienceSummary = ({
    formula,
}: {
    formula: FormulaDetailModel;
}) => {
    const { data: audiences } = useAudiencesQuery();
    const audienceNames = getAudienceNames(formula.audiences ?? [], audiences);
    return <SummaryItem label="Audience" value={audienceNames} />;
};
